<template>
  <div class="btn-wrapper">
    <component
      class="btn"
      :is="tag"
      :href="href"
      :to="to === 'not-nuxt-link' ? false : localizedLink(to)"
      :class="`btn_${theme}`"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <span class="btn__text"> <slot /> </span>
    </component>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    tag: {
      type: String,
      default: 'button'
    },
    href: {
      type: String
    },
    to: {
      type: String,
      default: 'not-nuxt-link'
    },
    type: {
      type: String,
      default: 'button',
      validate: val => {
        return ['button', 'submit', 'reset'].indexOf(val) !== -1
      }
    },
    theme: {
      type: String,
      validate: val => {
        return ['black', 'white'].indexOf(val) !== -1
      }
    }
  }
}
</script>

<!-- <style lang="sass" > -->
<!-- .btn -->
<!-- display: inline-flex -->
<!-- border: 0 -->
<!-- background: transparent -->
<!-- padding: 32px 50px 34px -->
<!-- position: relative -->
<!-- cursor: pointer -->
<!-- border-radius: 40px -->
<!-- box-shadow: 7px 0 40px 0 rgba(0, 0, 0, 0.18) -->
<!-- +transition -->
<!-- &:before -->
<!-- content: '' -->
<!-- +fully() -->
<!-- border-radius: 40px -->
<!-- +transition -->
<!-- .no-touch &:hover -->
<!-- &:before -->
<!-- top: -9px -->
<!-- bottom: -9px -->
<!-- border-radius: 200px -->
<!-- &__text -->
<!-- position: relative -->
<!-- pointer-events: none -->
<!-- width: 100% -->
<!-- z-index: 2 -->
<!-- line-height: 1 -->
<!-- height: 100% -->
<!-- align-items: center -->
<!-- font-family: inherit -->
<!-- font-size: 16px -->
<!-- font-weight: 700 -->
<!-- line-height: 1 -->
<!-- letter-spacing: 1.5px -->
<!-- text-transform: uppercase -->

<!-- &_white -->
<!-- background: $white -->
<!-- &:before -->
<!-- background: $white -->
<!-- .btn__text -->
<!-- color: $black -->
<!-- &_black -->
<!-- background: $black -->
<!-- &:before -->
<!-- background: $black -->
<!-- .btn__text -->
<!-- color: $white -->

<!-- &:focus -->
<!-- outline: none -->

<!-- </style> -->



// WEBPACK FOOTER //
// components/_UI/BaseButton.vue